// import { Link } from "react-router-dom";
import PostLinkPreview from "../../post/components/PostLinkPreview";
import SharedPost from "../../post/components/SharedPost";

const PostDetailContent = ({ post }) => {

    // const getSharedImgSrc = (path) => {
    //     if (!path) return "/noAvatar.png"; 
    //     if (path.startsWith("http")) return path; 
    //     return "/upload/" + path;
    // };

    const extractUrlFromText = (text) => {
        if (!text) return null;
        const urlRegex = /(https?:\/\/[^\s]+)/g;
        const matches = text.match(urlRegex);
        return matches ? matches[0] : null;
    };

    const detectedUrl = post.linkUrl || extractUrlFromText(post.desc);

    const previewDataObj = (post.linkTitle || post.linkImg) ? {
        title: post.linkTitle,
        description: post.linkDesc,
        img: post.linkImg,
        url: post.linkUrl
    } : null;

    return (
        <div className="content">
            <p style={{ marginBottom: "10px" }}>
                {post.desc}
            </p>

            {detectedUrl && (
                <PostLinkPreview 
                    previewData={previewDataObj} 
                    url={detectedUrl} 
                />
            )}
            
            {/* {post.originalPostId && (
                <div className="sharedContentPreview">
                    <Link 
                        to={`/post/${post.originalPostId}`}
                        style={{ textDecoration: "none", color: "inherit" }}
                    >
                        <div className="sharedHeader">
                            <img src={getSharedImgSrc(post.originalProfilePic)} alt="" />
                            
                            <span>
                                {post.originalName}
                            </span>
                        </div>

                        <p className="sharedDesc">
                            {post.originalDesc}
                        </p>
                    </Link>
                </div>
            )} */}

            {post.originalPostId && (
                <SharedPost post={post} />
            )}
        </div>
    );
};

export default PostDetailContent;